<template>
  <span
    class="status-badge"
    :class="[statusClass, historico ? 'historico' : '']"
  >
    {{ formattedStatus }}
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    historico: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusClass() {
      return {
        "status-vigente": this.status === "Vigente",
        "status-invalidado": this.status === "Invalidado",
        "status-vencido": this.status === "Vencido",
        "status-inativo": this.status === "Inativo",
        "status-aguardando-pagamento":
          this.status === "Aguardando pagamento do boleto",
        "status-ativo-aguardando-pagamento":
          this.status === "Ativo aguardando pagamento do boleto"
      };
    },
    formattedStatus() {
      const statusMap = {
        Vigente: "Vigente",
        Invalidado: "Invalidado",
        Vencido: "Vencido",
        Inativo: "Inativo",
        "Aguardando pagamento do boleto": "Aguardando pagamento",
        "Ativo aguardando pagamento do boleto": "Ativo aguardando pagamento"
      };

      return statusMap[this.status] || this.status;
    }
  }
};
</script>

<style scoped>
.status-badge {
  padding: 3px 31px;
  border-radius: 20px;
}

.status-vigente {
  background-color: #00c254;
  color: white;
  display: inline-block;
  font-size: 10px;
}
.status-invalidado {
  background-color: #f8ba40;
  color: white;
  display: inline-block;
  font-size: 10px;
}
.status-vencido {
  background-color: #f03e3e;
  color: white;
  display: inline-block;
  font-size: 10px;
}
.status-inativo {
  background-color: #f03e3e;
  color: white;
  display: inline-block;
  font-size: 10px;
}
.status-aguardando-pagamento {
  background-color: #f8ba40;
  color: white;
  padding: 3px 10px;
  border-radius: 20px;
  display: inline-block;
  font-size: 10px;
}
.status-ativo-aguardando-pagamento {
  background-color: #f8ba40;
  color: white;
  padding: 3px 7px;
  border-radius: 20px;
  display: inline-block;
  font-size: 10px;
}

@media (max-width: 768px) {
  .historico {
    padding: 3px 5px;
  }
}
</style>
